import { route } from '@md/routing';
import { accessPermission } from '@md/users/permissions';
import {
  SALARY_VIEW_LIST,
} from '@md/finances/accessTokens';

const List = () => import('./views/List');

const SALARIES_PREFIX = 'cabinet:finances:salaries:';
const p = name => SALARIES_PREFIX + name;
const LIST = p('list');

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: accessPermission(SALARY_VIEW_LIST, options),
    }),

    { path: '', redirect: { name: LIST } },
  ];
}
